/*
  Product page "Delivery & offers" box: business-day delivery dates, free-delivery progress
  from the live cart, and a button that opens the advance payment popup.
*/
if (!customElements.get('m-delivery-offer')) {
  class MDeliveryOffer extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold) || 0;
      this.renderDates();
      if (this.querySelector('[data-free-delivery]')) {
        const text = this.querySelector('[data-free-text]');
        this.defaultText = text ? text.innerHTML : '';
        this.loadCart();
        // Re-check when the shopper comes back (back button, another tab) in case the cart changed elsewhere.
        this.onReturn = (event) => {
          if (event.type === 'pageshow' ? event.persisted : document.visibilityState === 'visible') this.loadCart();
        };
        window.addEventListener('pageshow', this.onReturn);
        document.addEventListener('visibilitychange', this.onReturn);
        if (window.DeliEvents && window.DeliTheme && DeliTheme.pubSubEvents) {
          this.unsubscribe = DeliEvents.subscribe(DeliTheme.pubSubEvents.cartUpdate, (event) => {
            if (event && event.cart && typeof event.cart.total_price === 'number') this.renderFree(event.cart.total_price);
            else this.loadCart();
          });
        }
      }
      const trigger = this.querySelector('[data-prepaid-trigger]');
      if (trigger) {
        trigger.addEventListener('click', () => {
          const offer = document.querySelector('m-prepaid-offer');
          if (offer && typeof offer.open === 'function') offer.open();
        });
        if (!document.querySelector('m-prepaid-offer')) trigger.hidden = true;
      }
    }

    disconnectedCallback() {
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
      if (this.onReturn) {
        window.removeEventListener('pageshow', this.onReturn);
        document.removeEventListener('visibilitychange', this.onReturn);
      }
    }

    /* Adds business days (Mon–Sat), skipping Sundays. */
    addBusinessDays(start, days) {
      const date = new Date(start);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0) added += 1;
      }
      return date;
    }

    renderDates() {
      const target = this.querySelector('[data-delivery-dates]');
      if (!target) return;
      const min = Number(this.dataset.minDays) || 3;
      const max = Number(this.dataset.maxDays) || min;
      const today = new Date();
      const from = this.addBusinessDays(today, min);
      const to = this.addBusinessDays(today, max);
      const day = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric' });
      const full = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      if (from.getTime() === to.getTime()) target.textContent = full(to);
      else if (from.getMonth() === to.getMonth()) target.textContent = `${day(from)} – ${full(to)}`;
      else target.textContent = `${full(from)} – ${full(to)}`;
    }

    loadCart() {
      fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`, { credentials: 'same-origin' })
        .then((response) => response.json())
        .then((cart) => this.renderFree(cart.total_price))
        .catch(() => {});
    }

    formatMoney(cents) {
      if (typeof window.formatMoney === 'function') {
        try {
          return window.formatMoney(cents, this.dataset.moneyFormat || undefined);
        } catch (error) {
          /* fall through */
        }
      }
      return `Rs.${(cents / 100).toLocaleString('en-PK')}`;
    }

    renderFree(total) {
      const text = this.querySelector('[data-free-text]');
      const bar = this.querySelector('[data-free-bar]');
      if (!text || !bar || !this.threshold) return;
      const remaining = this.threshold - total;
      const progress = Math.max(0, Math.min(1, total / this.threshold));
      bar.style.width = `${progress * 100}%`;
      if (remaining <= 0) {
        text.innerHTML = '<strong>You get free delivery</strong> on this order';
        this.classList.add('is-free');
      } else if (total > 0) {
        text.innerHTML = `Add <strong>${this.formatMoney(remaining)}</strong> more for <strong>free delivery</strong>`;
        this.classList.remove('is-free');
      } else {
        // Cart emptied: back to the starting message.
        text.innerHTML = this.defaultText;
        this.classList.remove('is-free');
      }
    }
  }
  customElements.define('m-delivery-offer', MDeliveryOffer);
}
